import React from "react";
import { services } from "../data/siteContent";

export default function ServiceGrid() {
  return (
    <section className="section" id="services">
      <div className="section-heading">
        <p className="eyebrow">Core Services</p>
        <h2>Dock work handled with speed, care, and clear reporting.</h2>
      </div>
      <div className="service-grid">
        {services.map((service) => (
          <article className="service-card" id={service.slug} key={service.slug}>
            <img src={service.image} alt="" />
            <div>
              <h3>{service.title}</h3>
              <p>{service.summary}</p>
              <ul>{service.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
